<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md7 lg8 xs12 sm11>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4 class="pull">Taller para Vicerrectoría</h4>
              <!-- PESTEL
              <p
                class="pull"
              >En relación a un análisis de as variables políticas, sociales, económicas, tecnológicas y ambientales; además, de los diversos desafíos globales en materia de educación superior se identifican datos e información clave para la proyección institucional y de las respectivas áreas del conocimiento.</p>
              -->
            </v-flex>
          </v-layout>
          <v-flex md12 lg12 xs12 sm12 v-if="siguiente">
            <iframe
              class="video"
              :src="video"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-flex>
          <v-flex md12 lg12 xs12 sm12 v-if="!siguiente">
            <iframe
              class="video"
              src="https://www.youtube.com/embed/UKOpnK5fC4k"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-flex>
          <!-- <v-btn small color="#EB7704" class="button" @click="changeVideo()">{{this.button}}</v-btn> -->
        </v-flex>
        <br />
      </v-flex>

      <v-flex md1.5 lg1.5 xs0 sm0 hidden-sm-and-down>
        <v-layout>
          <v-flex md12 lg12 xs12 sm12>
            <v-navigation-drawer floating permanent stateless class="drawner" value="true">
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="downloadFile(24,archivosGral)"
                        target="_blank"
                      >Informe 2017</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="downloadFile(25,archivosGral)"
                        target="_blank"
                      >Informe 2018</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="downloadFile(26,archivosGral)"
                        target="_blank"
                      >Informe 2019</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="downloadFile(27,archivosGral)"
                        target="_blank"
                      >Análisis del periodo</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="downloadFile(28,archivosGral)"
                        target="_blank"
                      >Rúbrica de avances</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="downloadFile(29,archivosGral)"
                        target="_blank"
                      >Informe PO periodo</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="downloadFile(30,archivosGral)"
                        target="_blank"
                      >Síntesis entrevista 2030</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
          </v-flex>
        </v-layout>
        <!-- <v-layout row>
          <v-flex md10 lg10 xs12 sm11>
            <img :src="img3" class="image" @click="dialog = true" />
          </v-flex>
        </v-layout>-->
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-navigation-drawer floating permanent stateless class="drawner" value="true">
          <v-list dense>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn small color="#EB7704" class="button" @click="dialog=true">Taller</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-list dense>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(0,filesDge)"
                    target="_blank"
                  >Descargar Entrevista</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
    </v-layout>

    <!-- <v-layout>
      <v-dialog v-model="dialog" width="700px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Taller</span>
            <p
              class="pull"
            >En relación a un análisis de as variables políticas, sociales, económicas, tecnológicas y ambientales; además, de los diversos desafíos globales en materia de educación superior se identifican datos e información clave para la proyección institucional y de las respectivas áreas del conocimiento.</p>
          </v-card-title>
          <v-card-text>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <v-btn
                  small
                  color="#EB7704"
                  class="button"
                  @click="downloadFile(19,archivosGral)"
                  target="_blank"
                >Descargar Taller</v-btn>
              </v-flex>
            </v-layout>
            <br />
            <v-layout>
              <v-layout align-center justify-center>
                <v-flex md9 lg9 xs9 sm9>
                  <v-layout>
                    <v-text-field
                      label="Taller a subir por vicerrectoría"
                      @click="pickFile('0')"
                      v-model="FileName[0]"
                      prepend-icon="attach_file"
                      :disabled="this.filesDge['dge']['4']['saved'] == 'si'"
                    ></v-text-field>
                    <input
                      type="file"
                      id="file0"
                      ref="myFiles0"
                      style="display: none"
                      class="custom-file-input"
                      @change="previewFiles('0')"
                      multiple
                    />

                    <v-btn
                      v-if="this.filesDge['dge']['4']['saved'] == 'si'"
                      fab
                      outline
                      small
                      color="#394049"
                      v-on:click="downloadFile('4',filesDge)"
                    >
                      <v-icon dark>save_alt</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="this.filesDge['dge']['4']['saved'] == 'no'"
                      fab
                      outline
                      small
                      color="#EC6A12"
                      v-on:click="submitFile('4')"
                      :disabled="disabled[0]"
                    >
                      <v-icon color="#394049" dark>publish</v-icon>
                    </v-btn>

                    <v-btn
                      v-if="this.filesDge['dge']['4']['saved'] == 'si'"
                      fab
                      outline
                      small
                      color="#EC6A12"
                      v-on:click="deleteFile('4')"
                    >
                      <v-icon color="#394049" dark>delete</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="dialog = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>-->
  </v-container>
</template>

<script>
import img1 from "../../assets/BANNER_3.png";
import img2 from "../../assets/entorno.png";
import img3 from "../../assets/nuevaasistencia.png";

export default {
  data() {
    return {
      disabled: [true],
      filess: {
        0: "",
        24: "",
        25: "",
        26: "",
        27: "",
        28: "",
        29: "",
        30: "",
        31: ""
      },
      FileName: {
        0: "",
        24: "",
        25: "",
        26: "",
        27: "",
        28: "",
        29: "",
        30: "",
        31: ""
      },
      archivosGral: "",
      siguiente: true,
      button: "Siguiente",
      dialog: false,
      plantilla: false,
      img2: img2,
      img3: img3,
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      filesDge: "",
      img1: img1,
      items: [
        {
          title: "° PESTEL",
          icon: "dashboard",
          path: "1"
        },
        { title: "° Tendencias", icon: "question_answer", path: "2" },
        { title: "° Análisis encuestas", icon: "question_answer", path: "3" },
        {
          title: "° Análisis de entrevistas",
          icon: "question_answer",
          path: "4"
        },
        { title: "° Posicionamiento USACH", icon: "question_answer", path: "5" }
      ],
      right: null,
      video: ""
    };
  },
  created() {
    if (
      this.$session.getAll().userType != "Vicerrector" &&
      this.$session.getAll().ccData.tipo != "Vicerrectoria"
    ) {
      alert("No puede acceder a esta sección");
      this.$router.push("/intro");
    }
    axios
      .get(
        process.env.ROOT_API +
          "/centrocosto/getLinkVideo?ccValor=" +
          this.$session.getAll().ccData.ccValor,
        this.auth
      )
      .then(response => {
        console.log(response.data);
        this.video = response.data;
        //console.log(this.filesDca);
        //console.log(this.filesDca["dge"][1]);
      })
      .catch(error => {
        console.error(error);
      });
  },
  mounted() {
    axios
      .get(
        process.env.ROOT_API +
          "/uploadFileDcaEtc/getByCcValor?ccValor=" +
          this.$session.getAll().ccData.ccValor,
        this.auth
      )
      .then(response => {
        this.filesDge = response.data;
        console.log(this.filesDge);
        //console.log(this.filesDge["dge"][4]);
      })
      .then(response => {
        axios
          .get(
            process.env.ROOT_API + "/uploadFileDcaEtc/getByCcValor?ccValor=0",
            this.auth
          )
          .then(response => {
            this.archivosGral = response.data;
            //console.log(this.filesDge);
            //console.log(this.archivosGral["dge"][19]);
          });
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    redirect(index) {
      this.typeEstrategico = index;
    },
    algo() {
      alert("algo");
    },

    downloadFile(index, item) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(item.dge[index]["path"]);
      var nameFile = item.dge[index]["name"];
      //console.log(nameFile);
      if (pathFile != "") {
        axios
          .get(
            process.env.ROOT_API +
              "/uploadFileDcaEtc/downloadFile?dir=" +
              pathFile,
            {
              responseType: "arraybuffer",
              headers: { Authorization: "" + this.$session.get("jwt") }
            }
          )
          .then(response => {
            //console.log("archivo descargado ....");
            //console.log(response);
            this.forceFileDownload(response, nameFile);
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        alert("Contenido no disponible");
      }
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },

    sendDge() {
      this.dialog = false;
      alert("Tus inquietudes han sido enviadas, pronto te contactaremos.");
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    changeVideo() {
      if (this.siguiente) {
        (this.siguiente = false), (this.button = "regresar");
      } else {
        (this.siguiente = true), (this.button = "siguiente");
      }
    },

    submitFile(index) {
      /*
                Initialize the form data
            */

      let formData = new FormData();
      var name = this.filess[0].name;
      //console.log("indice: " + index);
      /*
                Add the form data we need to submit
            */
      formData.append("file", this.filess[0]);
      //console.log(formData);

      /*
          Make the request to the POST /single-file URL
        */

      axios
        .post(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/createFile?cc=" +
            this.$session.getAll().ccData.ccValor,
          formData,
          this.auth
        )
        .then(response => {
          //console.log("SUCCESS!!");
          //console.log(response.data);
          this.path = response.data;
          this.filesDge.dge[index]["saved"] = "si";
          this.filesDge.dge[index]["path"] = response.data[0];
          this.filesDge.dge[index]["name"] = response.data[1];
          alert("Archivo: " + name + " fue cargado exitosamente.");
        })
        .catch(error => {
          //console.log("FAILURE!!");
          alert("Error al cargar el archivo" + name + " ," + error);
        })
        .then(response => {
          axios
            .post(
              process.env.ROOT_API +
                "/uploadFileDcaEtc/updateFileValue?ccValor=" +
                this.$session.getAll().ccData.ccValor +
                "&tipoData=dge",
              this.filesDge.dge,
              this.auth
            )
            .then(response => {
              //console.log(response.data);
              //console.log("funcionando");
            })
            .catch(error => {
              console.error(error);
            });
        });
    },

    /*
        Handles a change on the file upload
      */
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      //console.log(this.file);
    },

    deleteFile(index) {
      //console.log(index);
      //console.log(this.auth);
      axios
        .post(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/eraseFile?idCc=" +
            this.$session.getAll().ccData.ccValor +
            "&index=" +
            index,
          this.auth
        )
        .then(response => {
          //console.log(response);
          alert("Archivo eliminado exitosamente");
          this.cargaArchivos();
        })
        .catch(error => {
          console.error(error);
        });
    },

    cargaArchivos() {
      (this.filess = {
        0: ""
      }),
        (this.FileName = {
          0: ""
        });

      (this.disabled = [true]),
        axios
          .get(
            process.env.ROOT_API +
              "/uploadFileDcaEtc/getByCcValor?ccValor=" +
              this.$session.getAll().ccData.ccValor,
            this.auth
          )
          .then(response => {
            this.filesDge = response.data;
            //console.log(this.filesDge);
          })
          .catch(error => {
            console.error(error);
          });
    },
    previewFiles(index) {
      //console.log(index);
      this.filess[index] = this.$refs["myFiles" + index].files[0];
      //console.log(this.filess);
      this.FileName[index] = this.$refs["myFiles" + index].files[0].name;
    },
    pickFile(index) {
      //console.log("entrando a pick file");
      this.$refs["myFiles" + index].click();
      this.disabled[index] = false;
    }
  }
};
</script>


<style scoped>
.carousel {
  height: 425px !important;
  width: 425px !important;
  margin: auto !important;
}
.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.dialog_plantilla {
  width: 450px !important;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.image {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/planes de desarrollo/Vicerrectoria.vue